import React, { lazy, Suspense } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { LoginPage } from "./../pages/LoginPage/LoginPage";
import { ResetPasswordPage } from "./../pages/ResetPasswordPage/ResetPasswordPage";
import {
  CheckForMobileLayout,
  SuspenceLoader,
  PrivateRoute,
} from "../_components";
import { history } from "../_helpers";
import { roles } from "../_constants";
import "./App.css";

const DashboardPage = lazy(() =>
  import("../pages/DashboardPage/DashboardPage")
);

const App = () => {
  const {
    ROLE_ADMIN,
    ROLE_WATCHER,
    ROLE_SUPPORT,
    ROLE_ANALYZER,
    ROLE_SUPPORT_L1,
    ROLE_SUPPORT_L2,
    ROLE_SUPPORT_L3,
  } = roles;

  return (
    <Router history={history}>
      <Suspense fallback={<SuspenceLoader />}>
        <CheckForMobileLayout>
          <Switch>
            <PrivateRoute
              exact
              path="/dashboard/:path?/:id?"
              component={DashboardPage}
              roles={[
                ROLE_ADMIN,
                ROLE_WATCHER,
                ROLE_SUPPORT,
                ROLE_ANALYZER,
                ROLE_SUPPORT_L1,
                ROLE_SUPPORT_L2,
                ROLE_SUPPORT_L3,
              ]}
            />
            <Route path="/login">
              <LoginPage />
            </Route>
            <Route path="/resetpassword">
              <ResetPasswordPage />
            </Route>
            <Route path="/unauthorized">
              <h1>403 Error</h1>
            </Route>
            <Redirect from="*" to="/dashboard" />
          </Switch>
        </CheckForMobileLayout>
      </Suspense>
    </Router>
  );
};

export { App };
